import { twMerge } from '@panwds/tailwindcss';
import { isAfter, isBefore, isEqual } from 'date-fns';
import React from 'react';
import { List } from '../../List/List.js';
import { ListItem } from '../../List/ListItem.js';
import { layoutItemsModifier } from '../utilities/date2.logic.js';
function validateDateMinMax(date, max, min) {
    const isDateGrtEqMin = isAfter(date, min) || isEqual(date, min);
    const isDateLessEqMax = isBefore(date, max) || isEqual(date, max);
    return isDateGrtEqMin && isDateLessEqMax;
}
function validateDateRangeMinMax(startDate, endDate, max, min) {
    return validateDateMinMax(startDate, max, min) && validateDateMinMax(endDate, max, min);
}
export const LayoutList = (props) => {
    const { items, max, min, selectedOption, onSelectOption } = props;
    const style = {
        maxHeight: '100%',
        minWidth: '7.5rem',
        maxWidth: '7.5rem'
    };
    return (React.createElement(List, { dataTestId: `${props.dataTestId}-item-container`, dataMetrics: props.dataMetrics, ...(selectedOption === 'customs'
            ? {
                style: { ...style, borderRadius: 0, boxShadow: 'none' },
                addClassName: twMerge('twds-border-0 dark:twds-border-0', 'twds-border-r dark:twds-border-r twds-border-gray-300 dark:twds-border-gray-900', 'twds-bg-transparent dark:twds-bg-transparent')
            }
            : { style, addClassName: 'twds-bg-transparent dark:twds-bg-transparent' }) }, layoutItemsModifier(items).map((obj) => {
        const disabled = !!obj.dateRange &&
            (!obj.dateRange.startDate ||
                !obj.dateRange.endDate ||
                !validateDateRangeMinMax(obj.dateRange.startDate, obj.dateRange.endDate, max, min));
        return (React.createElement(ListItem, { dataTestId: `${props.dataTestId}-item-${obj.value}`, dataMetrics: props.dataMetrics, key: obj.value, value: obj.value, active: obj.value === selectedOption, addClassName: obj.value === selectedOption ? 'dark:twds-bg-gray-800' : 'dark:twds-bg-transparent', onClick: () => !disabled && onSelectOption(obj.value), disabled: disabled }, obj.label));
    })));
};
//# sourceMappingURL=layout_list.js.map